import { Space } from 'antd';
import { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { Routes } from '../../../../app/routes';
import LayoutInner from '../../../../layouts/main/components/layout-inner/layout-inner';
import GoBack from '../../../../shared/components/go-back/go-back';
import { useAppDispatch } from '../../../../store/hooks';
import AuthGuard from '../../../auth/components/auth-guard/auth-guard';
import RequestPreview from '../../../request/components/request-preview/request-preview';
import { setActiveRequestId } from '../../../request/store/requests-slice';
import SignRequestCreateModal from '../../../sign-requests/components/sign-request-create-modal/sign-request-create-modal';
import SignRequestInPortalModal from '../../../sign-requests/components/sign-request-in-portal-modal/sign-request-in-portal-modal';
import { UserPermissionType } from '../../../user/models/user-permission-type';
import ScanRequestCreateFormModal from '../../components/scan-request-create-form-modal/scan-request-create-form-modal';
import { setActiveScanRequestId } from '../../store/scan-requests-slice';
import styles from './scan-request.module.css';

const ScanRequest = (): JSX.Element => {
  const { t } = useTranslation('common');
  const { scanRequestId, requestId } = useParams();
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (scanRequestId && requestId) {
      dispatch(setActiveRequestId(requestId));
      dispatch(setActiveScanRequestId(scanRequestId));
    }

    return () => {
      dispatch(setActiveRequestId(null));
      dispatch(setActiveScanRequestId(null));
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [requestId, scanRequestId]);

  return (
    <AuthGuard permission={UserPermissionType.ViewDocuments}>
      <Helmet>
        <title>{t('signScanRequest.label.request')}</title>
      </Helmet>
      <LayoutInner>
        <Space className={styles.space} direction="vertical" size="middle">
          <GoBack fallbackRoute={Routes.ScanRequests}>{t('signScanRequest.label.request')}</GoBack>
          <RequestPreview fallbackRoute={Routes.ScanRequests} />
          <ScanRequestCreateFormModal />
          <SignRequestCreateModal />
          <SignRequestInPortalModal />
        </Space>
      </LayoutInner>
    </AuthGuard>
  );
};

export default ScanRequest;
